export default "__VITE_ASSET__f298dbbb__"